import expandIcon from '@SvgIcon/plus.svg';
import collapseIcon from '@SvgIcon/minus.svg';
import placeholderIcon from '@SvgIcon/../event-image-placeholder.svg';

import $ from 'jquery';
import moment from 'moment';

import svgIconHtml from '../../../shared/svgIconHtml';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUiDefault from 'photoswipe/dist/photoswipe-ui-default';
import map from 'lodash/map';

export default {
  name: 'ListEvent',

  props: {
    startDateText: {
      type: String,
      required: true,
    },

    endDateText: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    photo: {
      type: Object,
      default: null,
    },

    url: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      event: null,
      expanded: false,
      loading: true,
      hasLoaded: false,
    };
  },

  computed: {
    thumb() {
      if (!this.photo) {
        return null;
      }

      return `${this.photo.url.substring(0, this.photo.url.lastIndexOf('/'))}/_thumb/${this.photo.filename}`;
    },

    startDate() {
      return moment(this.startDateText);
    },

    endDate() {
      return moment(this.endDateText);
    },
  },

  methods: {
    toggle() {
      this.expanded = !this.expanded;
      this.loadData();
    },

    loadData() {
      if (this.hasLoaded) {
        return;
      }

      if (this.dataXhr) {
        this.dataXhr.abort();
      }

      this.loading = true;

      this.dataXhr = $.ajax({
        type: 'GET',
        url: this.url,
        dataType: 'json',
        success: (event) => {
          this.event = event;
          this.hasLoaded = true;
        },
      })
        .always(() => {
          this.loading = false;
        });
    },

    enlargePhoto() {
      const options = {
        index: 0,
        bgOpacity: 1,
        captionEl: false,
        fullscreenEl: false,
        shareEl: false,
        tapToClose: true,
        tapToToggleControls: false,
      };

      const photos = [
        {
          src: window.APP.context.site.files_url + this.event.photo.path,
          w: this.event.photo.width,
          h: this.event.photo.height,
        },
      ];

      const gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUiDefault, photos, options);
      gallery.init();
    },
  },

  created() {
    this.dataXhr = null;
    this.pswpElement = document.querySelectorAll('.pswp')[0];
  },

  template: `
    <div class="calendar__list__event">
      <button
          type="button" 
          class="calendar__list__event__header"
          @click="toggle"
        >
        <span class="calendar__list__event__header__icon">
          <template v-if="expanded">${svgIconHtml(collapseIcon)}</template>
          <template v-else>${svgIconHtml(expandIcon)}</template>
        </span>
        <span class="calendar__list__event__header__info">
          <span class="calendar__list__event__header__photo">
            <img v-if="thumb" :src="thumb" alt="">
            <template v-else>${placeholderIcon}</template>
          </span>
          <span class="calendar__list__event__header__date">
            {{ startDate | moment('MMMM Do') }}
            <span v-if="startDateText !== endDateText">
              – {{ endDate | moment('MMMM Do') }}
            </span>
          </span>
          <span class="calendar__list__event__header__title">{{ title }}</span>
        </span>
      </button>

      <div class="calendar__list__event__loading" v-if="expanded && loading">
        <ui-progress-circular :size="36" :indeterminate="true"/>
      </div>
      
      <div class="calendar__list__event__details" v-if="expanded && event">
        <div class="event">
          <div class="event__details">
            <div class="event__details__table-and-photo">
              <table class="transparent">
                <tbody>
                  <tr v-if="event.county">
                    <th scope="row">County:</th>
                    <td>{{ event.county }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Date:</th>
                    <td>
                      {{ startDate | moment('MMMM Do') }}
                      <span v-if="startDateText !== endDateText">
                        – {{ endDate | moment('MMMM Do') }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="event.timeStart || event.timeEnd">
                    <th scope="row">Time:</th>
                    <td>
                      {{ event.timeStart }}
                      <span v-if="event.timeEnd">
                        <span v-if="event.timeStart">—</span>
                        {{ event.timeEnd }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="event.location">
                    <th scope="row">Location:</th>
                    <td>{{ event.location }}</td>
                  </tr>
                  <tr v-if="event.url">
                    <th scope="row">Website:</th>
                    <td><a :href="event.url" target="_blank">{{ event.url }}</a></td>
                  </tr>
                  <tr v-if="event.address">
                    <th scope="row">Address:</th>
                    <td><nl2br tag="span" :text="event.address" /></td>
                  </tr>
                  <tr v-if="event.contactName || event.contactPhone || event.contactEmail">
                    <th scope="row">Contact:</th>
                    <td>
                      <div v-if="event.contactName">{{ event.contactName }}</div>
                      <div v-if="event.contactPhone">{{ event.contactPhone }}</div>
                      <div v-if="event.contactEmail">{{ event.contactEmail }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <div v-if="event.photo" class="photo">
                <img :src="event.photo.url" alt="" @click="enlargePhoto">
              </div>
            </div>
            
            <div v-if="event.richDescription" class="description" v-html="event.richDescription"></div>
            <div v-else-if="event.textDescription" class="description">
              <nl2br tag="p" :text="event.textDescription" />
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
};
